import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { setupAxios401Interceptor } from './setupAxios401Interceptor';
import App from './App';
import reportWebVitals from './reportWebVitals';

setupAxios401Interceptor();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
